var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(!_setup.activity)?[_c('el-container',[_c('el-header',{attrs:{"height":"auto"}},[_c(_setup.Header)],1),_c('el-main',[_c('router-view')],1),_c('el-footer',{attrs:{"height":"auto"}},[_c(_setup.Footer)],1)],1)]:[_c('router-view')],_c(_setup.Public)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }